import { ValidationFailure } from "@/api/models/FluentValidation/Results/validation-failure";
import { AnfrageService } from "@/api/service-index";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { PortalContextService } from "../../services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";

@Injectable({
    providedIn: 'root'
})
export class GetAnfrageValidationErrorsResolver  {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{ [key: string]: ValidationFailure[]; } | null> {

        await this.unfinishedHttpMethodsService.waitForAll();

        const id: string = this.portalContextService.CurrentItemContext?.id;
        const reportId = route.params['reportid'];
        if (id) {
            return this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: id, reportId: reportId }).toPromise();
        }

        return of(null).toPromise();
    }
}